<!--Responsive Design-->
<!-- inquiry rule redesign start -->
<p-dialog [(visible)]="display" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
          [styleClass]="'inquiry-modal createModal createInquiryModal'" [closable]="false" [dismissableMask]="true" [baseZIndex]="10000"
          [closeOnEscape]="true" [style]="{'height':'650px','max-width':'1770px', 'width': '90%', 'border-radius':'4px'}" [resizable]="false">
    <p-header>
        <div class="d-flex flex-row align-items-center justify-content-between mx-2 mt-1">
            <h6 class="gfid-title">Create Rule&nbsp;&nbsp;|&nbsp;&nbsp;GROUP NAME : {{selectedGroupName}}</h6>
            <button type="button" (click)="closeBtn()" class="d-flex flex-row close qma-text">
                <img src="assets/Inbox/close_icon_white.svg" alt="Close">
            </button>
        </div>
    </p-header>

    <div class="inquiryRulesAction" style="margin-bottom: 20px; margin-top: 20px;">
        <div class="inquiryRulesLeft">
            <div (click)="uploadInquiry()" class="downloadUploadbutton" pTooltip="Upload inquiry rules"
                 tooltipPosition="top" tooltipStyleClass="leftTooltip ui-tooltip-text">
                <img class="default-icon" src="assets/context/groupadminUpload.svg"/>
                Bulk Upload
            </div>
            <input name="files" id="files" type="file" multiple="false" style="display:none" #uploadFilesForInquiry
                   (change)="fileEventForInquiry($event)" accept=".xlsx" value=""/>
            <div class="buttonDivider"></div>
            <div (click)="download_rules()" class="inquiryDownload" pTooltip="Download form"
                 tooltipPosition="top" tooltipStyleClass="leftTooltip ui-tooltip-text">
                <img [src]="'assets/Inbox/downloadBlack.svg'" class="default-icon"/>
                Download Form
            </div>
        </div>
        <div class="inquiryRulesRight" *ngIf="routesList.length>0">
            <div class="inquiryRulesButton" *ngIf="!filterIconHide" pTooltip="Search inquiry rules"
                 tooltipPosition="top" tooltipStyleClass="leftTooltip ui-tooltip-text">
                <img src="assets/context/groupadminSearch.svg" (click)="filterIconClick()"/>
            </div>
            <div class="inbox-input" [ngClass]="{'hide':!filterIconHide}">
                <input class="inbox-filter-txtbox" type="text" placeholder="Filter..." (keyup)="onKey($event)"
                       [(ngModel)]="filterText" name='filterText'/>
                <img src="assets/qwyn/icons/close.svg" width=16 height="16" (click)="filterCloseClick()"
                     class="mail-box-filter-close-img" alt="Close" />
            </div>
            <div class="iconButtonDivider"></div>
            <div class="inquiryRulesButton" (click)="addRules(null, null, 'top')" pTooltip="Add inquiry rules"
                 tooltipPosition="top" tooltipStyleClass="leftTooltip ui-tooltip-text">
                <img src="assets/context/groupadminAdd.svg" />
            </div>
            <div class="iconButtonDivider"></div>
            <div class="inquiryRulesButton" (click)="copyInquiryRecords()" pTooltip="Copy inquiry rules"
                 tooltipPosition="top" tooltipStyleClass="leftTooltip ui-tooltip-text">
                <img src="assets/context/groupadminCopy.svg" />
            </div>
            <div class="iconButtonDivider"></div>
            <div class="inquiryRulesButton" (click)="checkDuplicate($event, duplicate)" pTooltip="Check duplicate rules"
                 tooltipPosition="top" tooltipStyleClass="leftTooltip ui-tooltip-text">
                <img src="assets/context/groupadminDuplicate.svg" />
            </div>
            <div class="iconButtonDivider"></div>
            <div class="inquiryRulesButton" (click)="restoreRulesShowPopUp($event, restoreRules)" pTooltip="Restore rules"
                    tooltipPosition="top" tooltipStyleClass="leftTooltip ui-tooltip-text">
                <img src="assets/context/groupadminRefresh.svg" />
            </div>
            <div class="iconButtonDivider"></div>
            <div class="inquiryRulesButton" (click)="setConfirmation('inquiryRules')" pTooltip="Delete rules"
                 tooltipPosition="top" tooltipStyleClass="leftTooltip ui-tooltip-text">
                <img src="assets/context/groupadminDelete.svg" />
            </div>
        </div>
    </div>
    <div *ngIf="!validationCheck">
        <span class="errorMsg">{{validationRules}}</span>
    </div>
    <div class="d-flex flex-row inquiry-rule">
        <!--        <ag-grid-angular style="width: 100%; height: 450px; " class="ag-theme-balham adminview" id="inquiryRules"
                    [rowData]="routesList" [columnDefs]="routesColumn" [stopEditingWhenCellsLoseFocus]="true"
                    [suppressRowClickSelection]="true" [pagination]="true" [defaultColDef]="inquiryRulesChecbox"
                    [singleClickEdit]="true" [rowSelection]="rowSelection" [paginationPageSize]="100"
                    (gridReady)="onGridReadyInquiry($event)" suppressPaginationPanel=true
                    (paginationChanged)="onPaginationChanged()" (selectionChanged)="onSelectionRules()"
                    [suppressDragLeaveHidesColumns]="true" suppressMenu=true [rowHeight]="43" [headerHeight]="44"
                    [modules]="modules">
                </ag-grid-angular>-->

        <ag-grid-angular
            #inquiryGrid
            style="width: 100%; height: 390px"
            class="ag-theme-balham peerTable inquiryTable"
            [rowData]="routesList"
            [columnDefs]="routesColumn"
            [stopEditingWhenCellsLoseFocus]="true"
            [suppressRowClickSelection]="true"
            [pagination]="true"
            [defaultColDef]="inquiryRulesChecbox"
            [singleClickEdit]="true"
            [rowSelection]="rowSelection"
            [paginationPageSize]="100"
            (gridReady)="onGridReadyInquiry($event)"
            (paginationChanged)="onPaginationChanged()"
            (selectionChanged)="onSelectionRules()"
            [suppressPaginationPanel]="true"
            [suppressMenuHide]="true"
            [suppressDragLeaveHidesColumns]="true"
            [suppressMakeColumnVisibleAfterUnGroup]="true"
            [suppressColumnVirtualisation]="true"
            [rowHeight]="32"
            [headerHeight]="44">
        </ag-grid-angular>
    </div>

    <!--check duplicate -->
    <p-overlayPanel [styleClass]="'duplicate_panel'" [appendTo]="'body'" [dismissable]="false" #duplicate
                    [baseZIndex]="9999">
        <p-header>
            <div class="d-flex flex-row align-items-center justify-content-between">
                <h6 class="new-rule">NEW RULES</h6>
                <h6 class="duplicate-rule"> DUPLICATE</h6>
                <button type="button" (click)="hideDuplicateModal(duplicate)" class="d-flex flex-row close qma-text"
                        style="border:none !important;opacity:1">
                    <img src="assets/Inbox/close_icon_u73.svg" alt="Close">
                    <h6>CLOSE</h6>
                </button>
            </div>
        </p-header>
        <div style="width: 100%; height :1px; border: 1px solid #002d72"></div>
        <div style="background-color: rgba(0, 189, 242, 0.06);">
            <div class="d-flex flex-row align-items-center justify-content-between" style="width: 100%; height: 43px;">
                <span class="gfid-title" style="font-size: 14px;margin-left: 7em;">FROM </span>
                <span class="gfid-title" style="font-size: 14px;width: 3em;">SUBJECT </span>
                <span class="gfid-title" style="font-size: 14px;width: 26em;">TO </span>
            </div>
            <div style="width: 100%; height :1px;"></div>
        </div>
        <div class="d-flex flex-row inquiry-rule">
            <ag-grid-angular #inquiryGridDuplicate style="width: 100%; height: 441px; " class="ag-theme-balham admindrp"
                             id="inquiryRulesGridDuplicate" [rowData]="duplicateList" [columnDefs]="duplicateColumn"
                             [stopEditingWhenCellsLoseFocus]="true" [suppressRowClickSelection]="true" [pagination]="true"
                             [defaultColDef]="duplicateCheckBox" [singleClickEdit]="true" [rowSelection]="rowSelection"
                             [paginationPageSize]="100" (gridReady)="onGridDuplicate($event)" suppressPaginationPanel=true
                             (paginationChanged)="onPaginationChanged()" (selectionChanged)="onSelectionRules()"
                             [suppressDragLeaveHidesColumns]="true" suppressMenu=true [rowHeight]="43" [headerHeight]="44"
                             [suppressHorizontalScroll]="true" (rowDataChanged)="dupGridRowDataChanged($event)">

            </ag-grid-angular>
        </div>
    </p-overlayPanel>
    <p-overlayPanel [styleClass]="'inq-rules-restore-overlay'" [appendTo]="'body'" [dismissable]="false" #restoreRules
                    [baseZIndex]="9999">
        <p-header>
            <div class="d-flex flex-row align-items-center justify-content-between inq-rules-restore-header-container">
                <h6 class="qma-inq-rule-popup-header">Restore Inquiry Rules</h6>
                <div class="close-button" (click)="closeRestorePopup($event, restoreRules)">
                    <img src="assets/qwyn/icons/close.svg" alt="close">
                </div>

            </div>
        </p-header>

        <div class="inq-restore-content">
            <div>
                The inquiry rules will be restored to the version saved last on
            </div>
            <div class="inq-restore-calender">
                <em class="pi pi-calendar"></em> <span class="inq-retore-date">{{restoreInquiryDate}}</span>
            </div>
            <div>
                Are you sure you want to go head with the restore ?
            </div>
        </div>
        <div class="footer">
            <button pButton label="Cancel" class="cancel-button" (click)="closeRestorePopup($event, restoreRules)"></button>
            <button pButton label="Restore" class="submit-button" (click)="confirmRestoreRules($event, restoreRules)"></button>
        </div>
    </p-overlayPanel>

    <div style="height:40px!important" class="inquiryRulesTableBottom qma-mailbox-pagination-container">
        <div class="d-flex align-items-center">
              <span>
                <img [ngClass]="{'pagination-img-disabled':disablePaginationPrevFirst}"
                     (click)="onBtFirst()"
                     id="btFirst"
                     class="pagination-img"
                     src="assets/Inbox/lineLeftButton.svg"
                     alt="First"
                     style="margin-right: 10px;"/>
              </span>
            <span class="separator-right">
                <img id="btPrevious"
                     [ngClass]="{'pagination-img-disabled':disablePaginationPrevFirst}"
                     (click)="onBtPrevious()"
                     class="pagination-img"
                     src="assets/Inbox/leftButton.svg"
                     alt="Previous"/>
              </span>

            <span id="lbCurrentPage" class="separator-right pagination-text-padding inquiryPageNo">
                {{lbCurrentPage}}
            </span>
            <span class="separator-right pagination-text-padding" style="margin-right: 4px;">of</span>
            <span id="lbTotalPages" class="separator-right pagination-text-padding">
                {{lbTotalPages}}
            </span>
            <span>
                <img [ngClass]="{'pagination-img-disabled':disablePaginationNextLast}"
                     id="btNext"
                     (click)="onBtNext()"
                     class="pagination-img"
                     src="assets/Inbox/rightButton.svg"
                     alt="Next"
                     style="margin-right: 10px;margin-left: 14px;"/>
              </span>
            <span class="separator-right">
                <img [ngClass]="{'pagination-img-disabled':disablePaginationNextLast}"
                     id="btLast"
                     (click)="onBtLast()"
                     class="pagination-img"
                     src="assets/Inbox/lineRightButton.svg"
                     alt="Last"/>
              </span>
        </div>

        <div class="d-flex align-items-center">
              <span class="value inquiryRuleTableRulesCountNo" id="lbPageSize">
                  {{lbPageSize}}</span>
            <span class="separator inquiryRuleTableRulesCount" style="margin-left: 4px;">
                of
            </span>
            <span class="value separator inquiryRuleTableRulesCount" id="lbTotalRecords" style="margin-left: 4px;">
                {{lbTotalRecords}}
            </span>
            <span class="separator separator-right inquiryRuleTableRulesCount" style="margin-left: 4px;">
                Rules
            </span>
        </div>
    </div>

    <div class="footer">
        <button class="cancel-button" (click)="hideModal()">Reset</button>
        <button class="submit-button" (click)="saveInquiryRules()">Confirm</button>
    </div>

</p-dialog>
<!-- for sucess and error -->
<p-dialog [(visible)]="displaySuccess" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
          [styleClass]="'contextMenuModal successModal'" [closable]="false" [dismissableMask]="true" [baseZIndex]="10000"
          [closeOnEscape]="true" [style]="{width: '30%'}">
    <p-header>
        <div class="d-flex flex-row align-items-center justify-content-between">
            <h6 class="success-title">Success Confirmation</h6>
            <button type="button" (click)="closeModal('success')" class="d-flex flex-row close qma-text">
                <img src="assets/Inbox/close_icon_white.svg" alt="Close">
            </button>
        </div>
    </p-header>
    <div class="success-msg"> Inquiry rule has been saved successully</div>
</p-dialog>
<p-dialog [(visible)]="displayError" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
          [styleClass]="'contextMenuModal failureModal'" [closable]="false" [dismissableMask]="true" [baseZIndex]="10000"
          [closeOnEscape]="true" [style]="{width: '30%'}">
    <p-header>
        <div class="d-flex flex-row align-items-center justify-content-between">
            <h6 class="success-title">Error Message</h6>
            <button type="button" (click)="closeModal('error')" class="d-flex flex-row close qma-text">
                <img src="assets/Inbox/close_icon_u73.svg" alt="Close">
                <h6>CLOSE</h6>
            </button>
        </div>
    </p-header>
    <div class="success-msg">Error while saving Inquiry rule !</div>
</p-dialog>
<!-- Not access for creating rule -->
<p-dialog [(visible)]="isNotAuthorize" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
          [styleClass]="'contextMenuModal errorModal ModelClose'" [closable]="true" [dismissableMask]="true"
          [baseZIndex]="10000" [closeOnEscape]="true" [style]="{width: '30%'}">
    <p-header>
        <div class="d-flex flex-row align-items-center justify-content-between">
            <h6 class="success-title">Error Message</h6>
        </div>
    </p-header>
    <div class="success-msg">{{errorMessage}}</div>
</p-dialog>
<!--Confirmation popup window-->
<!-- Jira:4703 : Confirmation Dialog before delete -->
<p-dialog [(visible)]="showPopUpDelete" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
          [styleClass]="'contextMenuModal'" [closable]="false" [dismissableMask]="true" [baseZIndex]="10000"
          [closeOnEscape]="true" [style]="{'max-width':'500px','width':'50%'}">
    <p-header>
        <div class="d-flex flex-row align-items-center justify-content-between mx-2 mt-1">
            <h6 class="reage-title">Confirm Action</h6>
            <!-- Jira:4703 : close button on dialog for confirmation of delete -->
            <button type="button" (click)="onCancel()" class="d-flex flex-row close qma-text">
                <img src="assets/Inbox/close_icon_u73.svg" alt="Close">
            </button>
        </div>
    </p-header>
    <div class="reage-body mx-2">
        <div class="d-flex flex-row align-items-center mb-4 pb-4">
            <label>{{confirmMsgText}}</label>
        </div>
    </div>
    <div class="footer">
        <button pButton label="Cancel" class="cancel-button" (click)="onCancel()"></button>
        <button pButton label="Confirm" class="submit-button" (click)="onOk()"></button>
    </div>
</p-dialog>

<!--Inquiry Rules Upload Message -->
<p-dialog [(visible)]="inquiryRulesUpload" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
          [styleClass]="'contextMenuModal successModal ModelClose'" [closable]="true" [dismissableMask]="true"
          [baseZIndex]="10000" [closeOnEscape]="true" [style]="{width: '20%'}">
    <p-header>
        <div class="d-flex flex-row align-items-center justify-content-between">
            <h6 class="success-title">{{inquiryRulesMsgTitle}}</h6>
        </div>
    </p-header>
    <div class="success-msg">{{inquiryRulesMsg}}</div>
</p-dialog>

<!--Inquiry Rules Upload Message - Confirmation box -->
<p-dialog [(visible)]="inquiryRulesConfirm" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
          [styleClass]="'contextMenuModal'" [closable]="false" [dismissableMask]="true" [baseZIndex]="10000"
          [closeOnEscape]="true" [style]="{'max-width':'500px','width':'50%'}">
    <p-header>
        <div class="d-flex flex-row align-items-center justify-content-between mx-2 mt-1">
            <h6 class="reage-title">Confirm Action</h6>
            <button type="button" (click)="onInquiryRulesCancel()" class="d-flex flex-row close qma-text">
                <img src="assets/Inbox/close_icon_u73.svg" alt="close">
            </button>
        </div>
    </p-header>
    <div class="reage-body mx-2">
        <div class="d-flex flex-row align-items-center mb-4 pb-4">
            <label>{{inquiryRulesMsg}}</label>
        </div>
    </div>
    <div class="footer">
        <button pButton label="Cancel" class="cancel-button" (click)="onInquiryRulesCancel()"></button>
        <button pButton label="Confirm" class="submit-button" (click)="onInquiryRulesConfirm()"></button>
    </div>
</p-dialog>

<!-- Inquiry Rules Upload - Reject Row Message -->
<p-dialog [(visible)]="inquiryRulesRejected" [modal]="true" [responsive]="true" [maximizable]="false"
          [appendTo]="'body'" [styleClass]="'contextMenuModal'" [closable]="false" [dismissableMask]="true"
          [baseZIndex]="10000" [closeOnEscape]="true" [style]="{'max-width':'550px','width':'100%'}">
    <p-header>
        <div class="d-flex flex-row align-items-center justify-content-between mx-2 mt-1">
            <h6 class="reage-title">Warning</h6>
            <button type="button" (click)="onInquiryRulesRejectedConfirm()" class="d-flex flex-row close qma-text">
                <img src="assets/Inbox/close_icon_u73.svg" alt="Close">
            </button>
        </div>
    </p-header>
    <div class="reage-body mx-2">
        <div class="d-flex flex-column reject-list">
            <label *ngFor="let rowMessage of invalidRowMessage">{{rowMessage}}</label>
        </div>
    </div>
    <div class="footer">
        <button pButton label="Confirm" class="submit-button" (click)="onInquiryRulesRejectedConfirm()"></button>
    </div>
</p-dialog>
